// API utility for email validation
export const validateEmails = async (campaignId, emailAddresses) => {
  try {
    const response = await fetch(`/api/v1/campaign/${campaignId}/validate_emails`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email_addresses: emailAddresses
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.email_validations;
  } catch (error) {
    console.error('Error validating emails:', error);
    throw error;
  }
};

// New function for standalone email validation (without campaign ID)
export const validateEmailsStandalone = async (emailAddresses) => {
  try {
    const response = await fetch('/api/v1/validate_emails', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email_addresses: emailAddresses,
        standalone: true
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.email_validations;
  } catch (error) {
    console.error('Error validating emails standalone:', error);
    throw error;
  }
};

// Helper function to get validation color from stored data
export const getValidationColor = (email, validations) => {
  if (validations && validations[email]) {
    return validations[email].ui_color;
  }
  return 'default';
};

// Helper function to get validation status message from stored data
export const getValidationStatus = (email, validations) => {
  if (validations && validations[email]) {
    return validations[email].status_message;
  }
  return 'Not validated';
};

// Helper function to check if email needs validation
export const needsValidation = (email, validations) => {
  return !validations || !validations[email];
};
